"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._days = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var utc_1 = __importDefault(require("dayjs/plugin/utc"));
var timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
var advancedFormat_1 = __importDefault(require("dayjs/plugin/advancedFormat"));
var toObject_1 = __importDefault(require("dayjs/plugin/toObject"));
var duration_1 = __importDefault(require("dayjs/plugin/duration"));
dayjs_1.default.extend(utc_1.default); // day.utc day.isUTC 등의 구문을 추가
dayjs_1.default.extend(timezone_1.default); // day.tz() 타임존 추가
dayjs_1.default.extend(advancedFormat_1.default); // day.format() 의 포맷 형식을 확장
dayjs_1.default.extend(toObject_1.default); // day.toObject 날짜를 객체형식으로 반환
dayjs_1.default.extend(duration_1.default); // duration
var week = ["일", "월", "화", "수", "목", "금", "토"];
var _days = /** @class */ (function () {
    function _days() {
    }
    /**
     * @returns 기본 dayjs methods 사용을 위함
     */
    _days.day = dayjs_1.default;
    _days.timezone = function (date, timezone) {
        if (timezone === void 0) { timezone = "DEFAULT"; }
        var _date = date === "now" ? (0, dayjs_1.default)() : (0, dayjs_1.default)(date);
        var resultDate = function () {
            switch (timezone) {
                case "UTC": {
                    return _date.tz("Africa/Abidjan");
                }
                case "EST": {
                    return _date.tz("America/New_York");
                }
                case "KST": {
                    return _date.tz("Asia/Seoul");
                }
                case "JST": {
                    return _date.tz("Asia/Tokyo");
                }
                case "DEFAULT":
                default: {
                    return _date;
                }
            }
        };
        dayjs_1.default.prototype.formatType = function formatType(format) {
            var formatTypes = format === "TIME" ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD";
            return resultDate().format(formatTypes);
        };
        return resultDate();
    };
    _days.dateAt = function (value, type, options) {
        var format = options.format, setTime = options.setTime, unit = options.unit, date = options.date;
        var formatType = format === "TIME" ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD";
        var Date = date ? (0, dayjs_1.default)(date) : (0, dayjs_1.default)();
        var result = null;
        if (0 === Number(value)) {
            result = Date;
        }
        result = type === "add" ? Date.add(value, unit) : type === "subtract" ? Date.subtract(value, unit) : Date;
        result =
            setTime === "startAt" ? result.hour(0).minute(0).second(0) : setTime === "endAt" ? result.hour(23).minute(59).second(59) : result;
        return format ? result.format(formatType) : result;
    };
    _days.nowTimezone = function (timezone) {
        return (0, dayjs_1.default)().tz(timezone);
    };
    _days.today = {
        week: (function () {
            var todayWeekIndex = new Date().getDay();
            return week[todayWeekIndex];
        })(),
    };
    return _days;
}());
exports._days = _days;
